import React, { Fragment } from 'react';

//TODO: Retry to make ProfileSideBar and ProfileNavbar async
/** Import component synchronously **/
import Navbar from '../../components/Navbar';

const navigations = ({
  //Props parameters destructured
  children,
  path,
  showProfile,
  sideBarClicked,
  userData,
  logout,
  lang,
  goBackToHome,
  goToProfile,
}) => {
  return (
    <Fragment>
      <Navbar
        path={path}
        showProfile={showProfile}
        lang={lang}
        goBackToHome={goBackToHome}
        goToProfile={goToProfile}
        logout={logout}
      />
      {children}
    </Fragment>
  );
};

export default navigations;
